import React, { useMemo, useState } from "react";
import Popover from "@material-ui/core/Popover";
import {
  getCaseFileOperationalWarnings,
  normalizeBagsFromFormAndApi,
} from "./caseFileOperationalWarnings";

export function CaseFileWarningsIcon({ warnings, compact }) {
  const [anchor, setAnchor] = useState(null);
  if (!warnings?.length) return null;
  return (
    <>
      <span
        role="button"
        tabIndex={0}
        onClick={(e) => setAnchor(e.currentTarget)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setAnchor(e.currentTarget);
          }
        }}
        style={{
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: 1,
          marginRight: compact ? 0 : 6,
          color: "#d97706",
          verticalAlign: "middle",
        }}
        title="Operational notices — click for details"
      >
        <i
          className="mdi mdi-alert-outline"
          style={{ fontSize: "1.125rem", lineHeight: 1, display: "block" }}
          aria-hidden
        />
      </span>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <div style={{ padding: "14px 16px", maxWidth: 360 }}>
          {warnings.map((w, idx) => (
            <div
              key={w.id}
              style={{
                marginBottom: idx < warnings.length - 1 ? 14 : 0,
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 14, color: "#92400e" }}>
                {w.title}
              </div>
              <div
                style={{
                  marginTop: 6,
                  fontSize: 13,
                  color: "#444",
                  lineHeight: 1.45,
                }}
              >
                {w.detail}
              </div>
            </div>
          ))}
        </div>
      </Popover>
    </>
  );
}

function useCaseFileWarnings(config, formData) {
  const data = config?.data;
  return useMemo(() => {
    const bags = normalizeBagsFromFormAndApi(formData?.Bags, data?.bags);
    return getCaseFileOperationalWarnings({
      type: formData?.Type ?? data?.type,
      departureDate: formData?.DepartureDate ?? data?.departure_date,
      flightDate: formData?.FlightDate ?? data?.flight_date,
      closed: data?.closed,
      caseStatus: formData?.CaseStatus ?? data?.case_status,
      bags,
    });
  }, [
    data?.bags,
    data?.case_status,
    data?.closed,
    data?.departure_date,
    data?.flight_date,
    data?.type,
    formData?.Bags,
    formData?.CaseStatus,
    formData?.DepartureDate,
    formData?.FlightDate,
    formData?.Type,
  ]);
}

export function renderCaseFileRemarksLabelPrefix({ config, formData }) {
  return <CaseFileRemarksLabelInner config={config} formData={formData} />;
}

function CaseFileRemarksLabelInner({ config, formData }) {
  const warnings = useCaseFileWarnings(config, formData);
  return <CaseFileWarningsIcon warnings={warnings} />;
}
